import type { ComponentProps } from 'react';

import { cn } from '@repo/lib/cn';

import { Skeleton } from '@/components/ui/skeleton';

export default function PostCardSkeleton(postSkeletonProps: ComponentProps<'div'>) {
  const { className, ...props } = postSkeletonProps;
  return (
    <div className={cn('bg-background flex w-full flex-col gap-5 rounded-2xl border p-4', className)} {...props}>
      <div className={'flex gap-4'}>
        <Skeleton className={'h-10 min-h-10 w-10 min-w-10 rounded-sm'} />
        <div className={'flex w-full flex-col justify-center gap-2'}>
          <Skeleton className={'h-3 w-14 rounded-sm'} />
          <Skeleton className={'h-3 w-10 rounded-sm'} />
        </div>
      </div>
      <div className={'flex flex-col gap-2'}>
        <Skeleton className={'h-3 w-full rounded-sm'} />
        <Skeleton className={'h-3 w-full rounded-sm'} />
        <Skeleton className={'h-3 w-[80%] rounded-sm'} />
        <Skeleton className={'h-3 w-[20%] rounded-sm'} />
      </div>
    </div>
  );
}
